import { toUnityFixed } from '../../../../helpers/unityHelper';
import { changeMattressView } from '../ProductBuilderComponents/commonHelper';

export class UndoRedoView {
  constructor({ undoRedoInstance }) {
    this.undoRedo = undoRedoInstance;
    this.pending = new Map();
    this.createAction = this.undoRedo.createAction;
    this._init();
  }

  _init() {
    this._pushViewChange = this.createAction(
      ({ prevValue, nextValue, viewType, viewData, idx, updateCallback }) => {
        if (prevValue === nextValue) return false;
        
        return {
          __ACTION__: 'VIEW_SLIDER_CHANGE',
          undo: () => {
            changeMattressView({
              type: viewType,
              gap: viewType === 'Exploded' ? prevValue * 0.35 : prevValue,
              isValueForViewChanged: true,
              isViewChangeUIClicked: true,
            });
            updateCallback?.(idx, prevValue);
          },
          redo: () => {
            changeMattressView({
              type: viewType,
              gap: viewType === 'Exploded' ? nextValue * 0.35 : nextValue,
              isValueForViewChanged: true,
              isViewChangeUIClicked: true,
            });
            updateCallback?.(idx, nextValue);
          },
        };
      }
    );

    // Add new action for view type changes (Normal, Exploded, Cutaway)
    this._pushViewTypeChange = this.createAction(
      ({ prevView, nextView, applyViewChange }) => {
        if (prevView?.view === nextView?.view) return false;
        
        return {
          __ACTION__: 'VIEW_TYPE_CHANGE',
          undo: async () => {
            await applyViewChange(prevView, false);
          },
          redo: async () => {
            await applyViewChange(nextView, false);
          },
        };
      }
    );
  }

  startViewChange({ viewType, initialValue, idx }) {
    const key = `${viewType}__${idx}`;
    this.pending.set(key, {
      viewType,
      initialValue: toUnityFixed(initialValue, 3),
      idx,
    });
  }

  updatePendingChange({ viewType, currentValue, idx }) {
    const key = `${viewType}__${idx}`;
    const item = this.pending.get(key);
    if (!item) return;
    item.lastValue = toUnityFixed(currentValue, 3);
  }

  endViewChange({ viewType, finalValue, idx, viewData, updateCallback }) {
    const key = `${viewType}__${idx}`;
    const item = this.pending.get(key);
    if (!item) return;
    
    const prevValue = item.initialValue;
    const nextValue = toUnityFixed(finalValue, 3);
    
    this._pushViewChange({
      prevValue,
      nextValue,
      viewType,
      viewData,
      idx,
      updateCallback,
    });
    
    this.pending.delete(key);
  }

  addViewTypeChangeAction({ prevView, nextView, applyViewChange }) {
    this._pushViewTypeChange({
      prevView,
      nextView,
      applyViewChange,
    });
  }

  clearAll() {
    this.pending.clear();
  }
}
